import { IAuthUser } from "../auth/types";

export function isManager(user: IAuthUser): boolean {
  return user?.role_id <= 3;
}

export function isAdmin(user: IAuthUser): boolean {
  return user?.role_id <= 2;
}
